import { FETCH_USERS_FULFILLED } from './actions';

import type { User } from '@/types/user';

export interface UsersAction {
  type: string;
  payload?: User[];
}

const usersReducer = (state: User[] = [], action: UsersAction): User[] => {
  if (action.type === FETCH_USERS_FULFILLED) {
    return action.payload ?? [];
  } else {
    return state;
  }
};

export { usersReducer };
